import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import { ClothesService } from '../../Services/clothes.service';
import { DiscountService } from '../../Services/discount.service';


@Component({
  selector: 'app-member-information',
  template: require('./member-information.component.html'),
  styles: [require('./member-information.component.css')]
})
export class MemberInformationComponent implements OnInit {
  discounts: any[] = [];
  clothes_men: any[] = [];
  clothes_woman: any[] = [];

  constructor(private discountService: DiscountService, private clothesService: ClothesService, private auth: AuthService) { }
  
  ngOnInit(){
    this.discountService.getDiscounts().subscribe( d => {
      this.discounts = d
      // console.log("Discounts: " +JSON.stringify(this.discounts));
    })

    this.clothesService.getAllClothes().subscribe( clothes =>{
      clothes.forEach((c:any) => {
        if (c.isMale) {
          this.clothes_men.push(c);
        }
        if (c.isFemale){
          this.clothes_woman.push(c)
        }
      });
      // console.log("Clothes_men: ",this.clothes_men);
      // console.log("Clothes_woman: ",this.clothes_woman);     
    })
  }

  compare( a:any, b:any ) {
    return Number(b.isMale) - Number(a.isMale)
  }

  isEmptyObject(obj: any) {
    var name;
    for (name in obj) {
        if (obj.hasOwnProperty(name)) {
            return false;
        }
    }
    return true;
  }

  showModal(imgpath: string){
    var img = document.getElementById('sizeTableImg') as HTMLImageElement;
    img.src = imgpath;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/member-information/member-information.component.ts